import { Component, Input, Injectable } from "@angular/core";
import {
  NgbActiveModal,
  NgbModal,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";

/**
 * @ignore
 */
@Component({
    selector: "ngbd-modal-content",
    template: `
    <div class="modal-header">
      <h4 class="modal-title">{{ title }}</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <p>{{ message }}</p>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-dark"
        (click)="activeModal.close('Close click')"
      >
        Close
      </button>
    </div>
  `,
    standalone: false
})
export class NgbdModalContent {
  @Input() title;
  @Input() message;
  constructor(public activeModal: NgbActiveModal) {}
}

/**
 * @ignore
 */
@Injectable()
export class AlertModalService {
  title: string;
  buttonTitle = "OK";
  type: "error";

  protected modalRef: NgbModalRef;

  constructor(protected modalService: NgbModal) {}

  public show(title: string, message: string) {
    this.modalRef = this.modalService.open(NgbdModalContent, {
      animation: true,
      centered: true,
      size: "lg",
    });
    this.modalRef.componentInstance.title = title;
    this.modalRef.componentInstance.message = message;
  }

  hide() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }
}
